<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
	<div style="display: flex; align-items: center;">
		<p class="modal-title">{{ data.nzTitle }}</p>
	</div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
	@if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
		@if (losses && losses.length > 0) {
			<nz-table #basicTable [nzData]="losses" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading" nzTableLayout="auto"
				[nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
				[nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }">
				<thead>
					<tr>
						<th nzWidth="225px">Razón</th>
						<th nzWidth="225px">Materia prima</th>
						<th nzWidth="225px">Producto final</th>
						<th nzWidth="225px">Observaciones</th>
						<th nzWidth="100px">Cantidad</th>
						<th nzWidth="150px">Fecha</th>
						<th nzWidth="120px">Operario</th>
					</tr>
				</thead>
				<tbody>
					@for (loss of basicTable.data; track index; let index = $index) {
					<tr>
						<td>{{ loss.lossReason?.name }}</td>
                        <td>
                            {{ (loss.rawMaterial?.article?.name ?? '') + (loss.rawMaterial?.articleBatch ? ('-' + loss.rawMaterial?.articleBatch?.batchNumber) : '' ) }}
                        </td>
                        <td>
                            {{ (loss.finalProduct?.article?.name ?? '') + (loss.finalProduct?.articleBatch ? ('-' + loss.finalProduct?.articleBatch?.batchNumber) : '' ) }}
                        </td>
						<td>{{ loss.observations }}</td>
						<td class="text-right">
							{{ loss.quantity }} {{ loss.measurementUnit?.abbreviation }}
						</td>
						<td>{{ (loss.createdAt | date: "dd/MM/YYYY HH:mm:ss") }}</td>
						<td>{{ loss.createdBy?.name }}</td>
					</tr>
					}
				</tbody>
			</nz-table>
		}
		@else {
			<div class="w-full h-full content-center">
				<nz-empty></nz-empty>
			</div>
		}
	}
</div>

<div *nzModalFooter>
	<div class="flex justify-end">
		<button (click)="handleCancel()" class="button secondary-button">
			Cerrar
		</button>
	</div>
</div>
